"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const search = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-search" : '') + (description ? " desc-search" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-search"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-search"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_2170)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.9065 1.31469C7.94265 -0.438231 11.6833 -0.438231 14.7195 1.31469C17.7557 3.06762 19.626 6.30715 19.626 9.813C19.626 12.2526 18.7357 14.4843 17.2623 16.2009L23.7804 22.7207C24.0732 23.0136 24.0732 23.4885 23.7803 23.7814C23.514 24.0476 23.0973 24.0718 22.8037 23.8539L22.7196 23.7813L16.2009 17.2623C14.4843 18.7357 12.2526 19.626 9.813 19.626C4.39343 19.626 0 15.2326 0 9.813C0 6.30715 1.87035 3.06762 4.9065 1.31469ZM13.9695 2.61373C11.3974 1.12876 8.22855 1.12876 5.6565 2.61373C3.08445 4.09871 1.5 6.84305 1.5 9.813C1.5 14.4041 5.22186 18.126 9.813 18.126C11.999 18.126 13.9879 17.2823 15.4718 15.9027L15.701 15.6813C17.1996 14.1778 18.126 12.1036 18.126 9.813C18.126 6.84305 16.5416 4.09871 13.9695 2.61373Z",
    fill: "inherit"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_2170"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = search;